import Script from 'next/script'
import { useBucket } from '@mc/experiments-react'

export const Maze = () => {
  const bucket = useBucket('maze-script')

  if (bucket !== 'on') return null

  return (
    <Script
      id='maze'
      dangerouslySetInnerHTML={{
        __html: `(function (m, a, z, e) {
            if (typeof m.sessionStorage === 'undefined') return // If sessionStorage not available, skip the snippet logic

            var s, t;
            try {
              t = m.sessionStorage.getItem('maze-us');
            } catch (err) {}

            if (!t) {
              t = new Date().getTime();
              try {
                m.sessionStorage.setItem('maze-us', t);
              } catch (err) {}
            }

            s = a.createElement('script');
            s.src = z + '?apiKey=' + e;
            s.async = true;
            a.getElementsByTagName('head')[0].appendChild(s);
            m.mazeUniversalSnippetApiKey = e;
        })(window, document, 'https://snippet.maze.co/maze-universal-loader.js', '15c7fe1a-4198-4130-bd90-6fa73c11f92a');`,
      }}
    />
  )
}
